import React, { Component } from 'react';
import '../css/App.css';
import { fetchData } from '../redux/assignedData/AssignAction'
import { connect } from 'react-redux'

import Sidenav from './Sidenav';
import Loader from '../component/Loader';

import IdleTimerLogout from './IdleTimerLogout';

class AreaAllocation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            q: ''

        };

    }

    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/');
        }

        this.props.getAreaData();
    }
    textInputInfo(e) {
        console.log(e.target.value)
        this.setState({
            q: e.target.value
        })
    }
    btnAction(models) {
        this.props.history.push('/unit', { data: models })
    }
    search(items) {

        return items.filter(item => item.name.toLowerCase().includes(this.state.q.toLowerCase()))


    }
    setValue(e) {
        e.preventDefault();
        this.setState({
            q: ''
        })
    }
    render() {
        console.log(this.props)
        return (
            <div className="">
                {/* <IdleTimerLogout/> */}
                {/* <Sidenav type={'second'} url={'/dashboard'}/> */}

                <nav class="navbar navbar-top navbar-expand navbar-dark  border-bottom" style={{
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    top: 0,
                    zIndex: 1
                }}>
                    <div class="container pad_z">
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <div className="col-sm-3 pad_z ">
                                <i className="material-icons back-btn grey-text" onClick={() => this.props.history.push('/dashboard')}>arrow_back</i>
                            </div>
                            <div className="col-sm-6 text-center pad_z" style={{ fontSize: 20 }}> Knowledge</div>
                            <div className="col-sm-3 text-right  pad_z vertical-align justify-content-end"></div>

                        </div>
                    </div>
                </nav>

                <div class="container">
                    <form className="col-12 text-center"
                        style={{ marginTop: 80 }} >
                        <div class="flex search mt-4">
                            <div class="form-group" style={{ width: '100%' }}>
                                <div class="input-group input-group-merge input-group-alternative">
                                    <input className="form-control" placeholder="Search..." type="text" value={this.state.q} onChange={(event) => this.textInputInfo(event)} />
                                </div>
                            </div>
                            <button class="form-control" type="submit" style={{ width: 50, color: '#000', background: '#dcdcdc' }} onClick={(e) => this.setValue(e)}><i class="fa fa-times"></i></button>
                        </div>
                    </form>
                </div>
                <div className="container">

                    <div className="row">
                        <div className="col-sm-12 pad_z">

                            {this.search(this.props.data).map((item, i) => {
                                return (

                                    <div className="card justify-content-center row" style={{ padding: 10, margin: 10, height: 70 }} key={i} onClick={() => this.btnAction(item)}>
                                        <div className="col-sm-2 col-xs-2 pad_z">
                                            {item.image ?
                                                <img src={item.image} alt="logo" className="responsive-img logo_size" style={{ width: 35 }} />
                                                : <span className="letter">{item.name.charAt(0)}</span>}
                                        </div>
                                        <div className="col-sm-9 col-xs-9 padZero flex align-space-between "><h2 className="topic_name" style={{ fontSize: 18, marginLeft: -30 }}>{item.name}</h2>
                                            <span className="topic" style={{ fontSize: 18, marginRight: -17 }}>{item.models.length} Topic(s) </span>
                                        </div>
                                        {item.completed && <i className="material-icons completed" style={{ background: item.completed }}>
                                            done
                                        </i>}

                                    </div>
                                )
                            })}

                        </div>
                    </div>

                </div>
                {this.props.loader && <Loader />}
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        data: state.assign.data,
        loader: state.assign.loading,
        error: state.assign.error
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getAreaData: () => dispatch(fetchData())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AreaAllocation);